module.exports = __webpack_public_path__ + "media/images/icons/outlined/step-backward-d2bfb938c876562a9fcffe810a0116c1.svg";